export const CONTROL_THEME = {
  background: 'hsl(var(--background))',
  card: 'hsl(var(--card))',
  cardForeground: 'hsl(var(--card-foreground))',
  foreground: 'hsl(var(--foreground))',
  muted: 'hsl(var(--muted))',
  mutedForeground: 'hsl(var(--muted-foreground))',
  accent: 'hsl(var(--accent))',
  border: 'hsl(var(--border))',
  primary: 'hsl(var(--primary))',
  primaryForeground: 'hsl(var(--primary-foreground))',
  ring: 'hsl(var(--ring))',
} as const;
